// GENERATED by `pnpm ndrc gen` — do not edit by hand.
export const CLIENT_LOADERS = {
  ads: () => import('@ndrc-apps/ads/client'),
  analytics: () => import('@ndrc-apps/analytics/client'),
  appel: () => import('@ndrc-apps/appel/client'),
  campaigns: () => import('@ndrc-apps/campaigns/client'),
  chat: () => import('@ndrc-apps/chat/client'),
  commerce: () => import('@ndrc-apps/commerce/client'),
  crm: () => import('@ndrc-apps/crm/client'),
  inbox: () => import('@ndrc-apps/inbox/client'),
  mini_sites: () => import('@ndrc-apps/mini_sites/client'),
  parcours: () => import('@ndrc-apps/parcours/client'),
  reputation: () => import('@ndrc-apps/reputation/client'),
  seo_lab: () => import('@ndrc-apps/seo_lab/client'),
  service_client: () => import('@ndrc-apps/service_client/client'),
  social_studio: () => import('@ndrc-apps/social_studio/client'),
  tableur: () => import('@ndrc-apps/tableur/client'),
  team: () => import('@ndrc-apps/team/client'),
  website: () => import('@ndrc-apps/website/client'),
} as const;
